{
  "version": 1,
  "asset_id": "5c0f4e17-b5c9-41e2-956d-46349b544d17",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5c0f4e17-b5c9-41e2-956d-46349b544d17/hero-new-800.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5c0f4e17-b5c9-41e2-956d-46349b544d17/hero-new-800.webp",
  "original_filename": "hero-new-800.webp",
  "size": 31734,
  "content_type": "image/webp",
  "created_at": "2026-07-25T03:21:11Z"
}
